import styled from 'styled-components';

type PlayButtonType = {
    isSelected: boolean;
};

export const PlayButton = styled.button<PlayButtonType>`
    height: 28px;
    width: 90px;
    border: ${({ isSelected }) => (isSelected ? '1px solid #0277BD' : 'none')};
    color: #1c1c1c;
    background-color: ${({ isSelected }) => (isSelected ? '#F3F8FC' : '#FFFFFF')};
    outline: none;
    border-radius: 3px;
    cursor: pointer;

    &:focus {
        outline: ${({ theme }) => `1px solid ${theme.colors.primary300}`};
    }
`;
